import React, { FunctionComponent } from 'react';
import { Link, useParams } from 'react-router-dom';
import { DataConnectionIcon, ErrorIcon } from 'evergreen-ui';
import styles from './IntegrationsView.module.css';
import ErrorPage from 'components/ErrorPage/ErrorPage';
import { AuthenticatedUserProps } from '../../hoc/WithAuthLayout';
import { useGetCompany } from '../../store/hooks/useCompany';
import RecruiteeCard from './RecruiteeCard/RecruiteeCard';

interface IntegrationsViewProps extends AuthenticatedUserProps {}

/**
 * Company-level integrations. Only company admins and super admins may manage
 * them; the route can be opened directly, so the gate lives here rather than
 * only on the entry button in CompanyView.
 */
const IntegrationsView: FunctionComponent<IntegrationsViewProps> = (props) => {
    const { userRoles } = props;
    const isSuperAdmin = userRoles.includes('super-admin');
    const hasCompanyAdminRole = userRoles.includes('company-admin');
    const { companySlug } = useParams();
    const { company } = useGetCompany(companySlug);

    const renderHeader = () => {
        return (
            <div className={styles.integrations_header}>
                <div className={styles.icon_container}>
                    <DataConnectionIcon size={33} />
                </div>
                <h1>Integrations</h1>
            </div>
        );
    };

    const renderInfoBox = () => {
        return (
            <div className={styles.integrations_info_box}>
                <Link to={`/${company ? company.slug : ''}`}>
                    <h2>{company ? company.name : 'Your company'}</h2>
                </Link>
                <p>Connect Neurolytics to the other tools your team uses.</p>
            </div>
        );
    };

    return (
        <>
            {(hasCompanyAdminRole || isSuperAdmin) && (
                <React.Fragment>
                    {renderHeader()}
                    {renderInfoBox()}
                    {companySlug && (
                        <RecruiteeCard companyIdentifier={companySlug} />
                    )}
                </React.Fragment>
            )}
            {!hasCompanyAdminRole && !isSuperAdmin && (
                <ErrorPage
                    icon={ErrorIcon}
                    iconColor={'danger'}
                    message="You do not have permission to view this page."
                />
            )}
        </>
    );
};

export default IntegrationsView;
